import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { Subscription } from "rxjs";
import { UserSettingsCategory } from "./user-settings-category";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { NavigationService } from "@ponder-core/navigation/navigation.service";

@Component({
    selector: "user-account-category-button",
    imports: [NgClass],
    templateUrl: "./user-account-category-button.component.html"
})
export class UserAccountCategoryButtonComponent {
    @Input({ required: true }) public svgIcon!: SvgIcon;
    @Input({ required: true }) public label!: string;
    @Input({ required: true }) public category!: UserSettingsCategory;
    @Input() public isSelected: boolean = false;
    @Input() public isLast: boolean = false;

    public svgIconStr!: string;
    private categorySelectedSub!: Subscription;

    public constructor(private events: EventBroker, private navigation: NavigationService) {
        this.categorySelectedSub = this.events.account.categorySelected.subscribe({
            next: (category: UserSettingsCategory) => {
                this.isSelected = (this.category == category);
            }
        });
    }

    public ngOnDestroy(): void {
        this.categorySelectedSub.unsubscribe();
    }

    public ngOnInit(): void {
        this.svgIconStr = SvgIconMap.get(this.svgIcon)!;
    }

    public onClicked(): void {
        if (this.isSelected) {
            return;
        }
        
        this.navigation.goto(`/account/${this.category}`)
    }
}